var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKingdom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8512 73.8518L18.5656 69.5915C18.5656 69.5915 22.1592 68.5011 23.709 66.1832C25.2589 63.8652 24.8807 52.5985 24.8807 51.5833C24.8807 50.5681 22.1279 50.056 17.2215 46.1927C12.3151 42.3295 11.3779 39.0322 11.3779 39.0322",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8809 35.7803C24.3315 37.3885 25.2686 40.9507 25.1064 42.7027C24.7685 46.2964 24.0567 45.9236 19.6999 43.2642C17.2219 41.7548 15.3071 38.6597 15.3071 38.6597",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7729 30.1289C26.7146 32.2267 29.0844 34.0236 29.0844 34.0236V25.5693",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0097 25.7988C39.8385 28.1097 39.8009 30.4285 39.897 32.7437L43.1274 28.7008",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2188 32.4688C45.732 35.447 44.4795 40.5277 44.6958 43.6991C44.9571 47.4321 46.1195 48.7214 46.1195 48.7214C46.1195 48.7214 49.3454 50.2667 53.22 46.9245C57.0947 43.5823 58.1264 39.9302 58.1264 39.9302",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8249 43.3535C59.9734 45.4334 57.6711 50.0378 53.0891 52.9533C47.0203 56.812 46.6328 56.547 46.6328 56.547C46.6328 56.547 46.5067 61.4389 47.0203 64.7856C47.5339 68.1323 48.2153 67.876 50.2833 69.1653C50.3941 69.2343 51.1405 71.2955 53.0891 72.9996",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0077 67.1092C29.1383 66.7228 28.5211 59.4725 28.422 51.6651C28.3228 43.8578 35.1531 38.1348 35.1531 38.1348C35.1531 38.1348 42.2221 44.3878 42.2221 51.6517C42.22 56.8231 41.9568 61.9911 41.4336 67.1361",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    "custom-rule": "true",
    d: "M32.2744 45.6222C34.7164 45.209 35.3156 46.7453 35.3156 46.7453C35.3156 46.6689 35.3922 46.0355 36.5546 45.5863C36.8199 45.462 37.1105 45.4006 37.4036 45.4068C37.6966 45.4131 37.9843 45.4868 38.2441 45.6222L35.1534 41.3906L32.2744 45.6222Z",
    fill: "#B250FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3394 60.6191C8.72517 60.4343 8.89291 59.9836 8.71404 59.6124C8.53518 59.2411 8.07745 59.09 7.69167 59.2748C7.3059 59.4596 7.13816 59.9103 7.31702 60.2815C7.49589 60.6528 7.95362 60.8039 8.3394 60.6191Z",
    fill: "#B250FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 58.2312C12.8336 58.2312 13.1039 57.9617 13.1039 57.6293C13.1039 57.2968 12.8336 57.0273 12.5002 57.0273C12.1668 57.0273 11.8965 57.2968 11.8965 57.6293C11.8965 57.9617 12.1668 58.2312 12.5002 58.2312Z",
    fill: "#B250FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 63.1213C11.8808 63.1213 12.0542 62.9483 12.0542 62.735C12.0542 62.5216 11.8808 62.3486 11.6668 62.3486C11.4528 62.3486 11.2793 62.5216 11.2793 62.735C11.2793 62.9483 11.4528 63.1213 11.6668 63.1213Z",
    fill: "#B250FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8553 60.6446C56.3287 60.6446 56.7125 60.2631 56.7125 59.7925C56.7125 59.3219 56.3287 58.9404 55.8553 58.9404C55.3818 58.9404 54.998 59.3219 54.998 59.7925C54.998 60.2631 55.3818 60.6446 55.8553 60.6446Z",
    fill: "#B250FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9989 69.1655C64.2356 69.1655 64.4275 68.9748 64.4275 68.7395C64.4275 68.5042 64.2356 68.3135 63.9989 68.3135C63.7622 68.3135 63.5703 68.5042 63.5703 68.7395C63.5703 68.9748 63.7622 69.1655 63.9989 69.1655Z",
    fill: "#B250FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4276 56.3848C64.901 56.3848 65.2848 56.0033 65.2848 55.5327C65.2848 55.0622 64.901 54.6807 64.4276 54.6807C63.9541 54.6807 63.5703 55.0622 63.5703 55.5327C63.5703 56.0033 63.9541 56.3848 64.4276 56.3848Z",
    fill: "#B250FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6878 58.513C38.6878 53.5698 38.8327 49.5684 36.8475 49.5684C35.9346 49.5684 35.4311 50.5185 35.1992 52.0797C34.9855 50.5394 34.5798 49.5684 33.6451 49.5684C31.8338 49.5684 31.8592 53.574 31.8592 58.513C31.8592 63.452 31.6454 67.4618 33.6451 67.4618H36.8403C39.0537 67.4618 38.6878 63.4562 38.6878 58.513Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5039 15.9746C10.4769 15.6512 10.4634 15.3278 10.4634 14.9998C10.4634 12.733 11.0928 10.5105 12.2819 8.57843C13.471 6.6464 15.1734 5.08034 17.2004 4.05377C19.2274 3.02721 21.4999 2.58022 23.766 2.76235C26.0322 2.94448 28.2035 3.74861 30.0394 5.08564",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4002 23.7598C29.6582 25.476 27.4383 26.6297 25.0296 27.0705V27.0705C24.287 27.2112 23.5327 27.2819 22.7769 27.2816",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34089 25.7179C3.30649 25.0335 2.52058 24.0351 2.0995 22.8707C1.67841 21.7062 1.64451 20.4375 2.00283 19.2524C2.36114 18.0672 3.09262 17.0286 4.08901 16.2902C5.0854 15.5518 6.29375 15.1528 7.53523 15.1524C8.58195 15.1487 9.60937 15.4332 10.5043 15.9744",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67829 32.774C2.85456 32.5556 2.1351 32.0533 1.64764 31.3562C1.16018 30.659 0.936275 29.8122 1.01568 28.9661C1.09509 28.1199 1.47267 27.3292 2.08138 26.7344C2.69009 26.1395 3.49053 25.779 4.34059 25.7168",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67823 32.7744C3.11286 33.3334 2.68979 34.0191 2.44433 34.7743C2.19886 35.5294 2.13813 36.3322 2.2672 37.1156C2.39627 37.8989 2.71139 38.6401 3.18627 39.2773C3.66114 39.9145 4.28199 40.4292 4.997 40.7785C5.71201 41.1277 6.50043 41.3014 7.29646 41.285C8.09249 41.2685 8.87303 41.0625 9.57294 40.6841C10.2728 40.3056 10.8718 39.7658 11.3198 39.1095C11.7679 38.4533 12.052 37.6997 12.1484 36.9117",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20215 31.7412C9.37366 32.9216 9.79788 34.0514 10.446 35.0539C11.0941 36.0565 11.951 36.9082 12.9584 37.5514C13.9658 38.1946 15.1002 38.6142 16.2847 38.7816C17.4691 38.9491 18.6758 38.8605 19.8228 38.522C20.9699 38.1834 22.0305 37.6027 22.9326 36.8194C23.8347 36.036 24.5572 35.0683 25.0511 33.982C25.545 32.8957 25.7987 31.7161 25.795 30.5233C25.7913 29.3306 25.5303 28.1526 25.0297 27.0693V27.0693",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6365 24.7648C40.9038 25.3817 40.0545 25.8459 39.1388 26.1298C38.223 26.4137 37.2595 26.5117 36.3051 26.4178C35.3508 26.324 34.425 26.0404 33.5825 25.5836C32.74 25.1268 31.998 24.5063 31.4002 23.7586C31.3551 23.7047 31.3101 23.6463 31.2695 23.5879",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6553 10.022C46.6584 8.85589 46.4318 7.70052 45.9885 6.62144C45.1979 4.68367 43.7564 3.08013 41.9107 2.08528C40.065 1.09044 37.9299 0.76616 35.8708 1.16795C33.8117 1.56974 31.9568 2.67262 30.6234 4.2878C29.29 5.90299 28.5611 7.93005 28.5615 10.022",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9888 6.62133C48.1906 5.35967 50.7555 4.87695 53.2671 5.25149C55.7787 5.62603 58.0897 6.83586 59.825 8.68463C61.5603 10.5334 62.618 12.9126 62.8265 15.4361C63.0351 17.9597 62.3822 20.4794 60.9738 22.5864C60.9738 22.5864 60.9738 22.5864 60.9738 22.5864C60.4778 23.3303 59.8939 24.012 59.2347 24.6169V24.6169L59.1491 24.6888",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1023 27.5636C50.7154 28.2455 50.1743 28.8279 49.522 29.2646C48.8697 29.7013 48.1242 29.9802 47.3448 30.0792C47.13 30.1101 46.9131 30.1251 46.696 30.1242C45.3518 30.1242 44.0625 29.5917 43.112 28.644C42.1615 27.6962 41.6274 26.4108 41.6274 25.0705C41.6274 24.9672 41.6274 24.8638 41.6274 24.765C41.6715 24.0108 41.8872 23.2765 42.2582 22.6178C42.6776 21.8624 43.2841 21.2268 44.0198 20.7715",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8086 26.639C68.7863 25.7403 68.5223 24.8641 68.0442 24.102C67.5661 23.3398 66.8914 22.7197 66.0907 22.3066C65.2899 21.8934 64.3926 21.7022 63.4924 21.7532C62.5922 21.8041 61.7223 22.0952 60.9736 22.5961C60.9736 22.5961 60.9736 22.5961 60.9736 22.5961",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8084 26.6387C70.0284 27.0123 71.0951 27.7682 71.8502 28.7941C72.6052 29.8201 73.0083 31.0615 72.9997 32.3339C72.9911 33.6064 72.5713 34.8422 71.8024 35.858C71.0336 36.8737 69.9568 37.6152 68.7318 37.9724C68.1922 38.1318 67.6322 38.212 67.0693 38.2105",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7322 37.9727C68.874 38.4387 68.9453 38.9232 68.9439 39.4101C68.9048 40.7144 68.3576 41.9521 67.4185 42.8608C66.4794 43.7695 65.2223 44.2778 63.9136 44.2778C62.605 44.2778 61.3478 43.7695 60.4087 42.8608C59.4696 41.9521 58.9225 40.7144 58.8833 39.4101C58.8831 39.2043 58.8966 38.9987 58.9239 38.7947",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2534 31.7461C63.2508 32.7014 63.0737 33.6482 62.7308 34.5402C62.5858 34.9274 62.4079 35.3016 62.1992 35.6588C61.323 37.1954 59.9615 38.3999 58.3271 39.0845C56.6926 39.7691 54.8769 39.8954 53.1629 39.4436C51.4489 38.9919 49.933 37.9876 48.8513 36.5871C47.7695 35.1867 47.1829 33.4688 47.1826 31.7012C47.1837 31.1581 47.238 30.6165 47.3448 30.084",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingdom);
export default __webpack_public_path__ + "static/media/kingdom.b6720dca79454baf5c9d55fb46969fa7.svg";
export { ForwardRef as ReactComponent };